import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsErrorHandler implements ErrorHandler {
  private readonly appInsights = inject(ApplicationInsightsService);

  handleError(error: Error): void {
    this.appInsights.trackException(error, {
      handler: 'ApplicationInsightsErrorHandler',
    });
    throw error;
  }
}
